import { connect } from 'react-redux';
import { IState } from '../../../reducers';
import { fetchTopNavigationMenuItemAction, toggleMobileNavigationMenuAction, updateTopNavigationMenuItemStateAction } from './actions/fetchTopNavigationMenuItems';

import TopNavigationMenuItem from '../../../api/topNavigationMenuEntity';
import { TopNavigationMenu } from './topNavigation';

const mapStateToProps = (state: IState) => ({
    topNavigationMenu: state.topNavigationMenu
});

const mapDispatchToProps = (dispatch: any) => ({
    fetchTopNavigationMenuItems: () => dispatch(fetchTopNavigationMenuItemAction()),
    toggleMobileNavigationMenu: () => dispatch(toggleMobileNavigationMenuAction()),
    updateTopNavigationMenuItemState:(subMmenuItem: TopNavigationMenuItem) => dispatch(updateTopNavigationMenuItemStateAction(subMmenuItem))
});

export const TopNavigationContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TopNavigationMenu);


// WEBPACK FOOTER //
// ./src/common/components/topNavigation/topNavigationContainer.tsx